import { IAppState } from '../context'
import { key } from '../reducers/menuReducer'

export const selectMenu = (appState: IAppState) => appState[key]
